import React from 'react';

var _getCookie = function(name) {
  var value = '; ' + document.cookie;
  var parts = value.split('; ' + name + '=');
  if (parts.length === 2)
    return parts
      .pop()
      .split(';')
      .shift();
  return null;
};

var _hasConsent = function() {
  return !!_getCookie('fs-consent');
};

var _parseFsConsent = function() {
  var raw = _getCookie('fs-consent');
  if (!raw) return null;
  try {
    return JSON.parse(decodeURIComponent(decodeURIComponent(raw)));
  } catch (e) {
    return null;
  }
};

export var _getConsentState = function() {
  var parsed = _parseFsConsent();
  // console.log({parsed})
  if (parsed && (parsed.consents || parsed.choices)) {
    var choices = parsed.consents || parsed.choices;
    return {
      analytics: !!choices.analytics,
      marketing: !!choices.marketing,
      personalization: choices.personalization !== false,
    };
  }

  return null;
};

var MARKETING_INTEGRATIONS = [
  'Facebook Pixel',
  'Facebook Conversions API',
  'Google Ads (Gtag)',
  'Google Ads (Classic)',
  'TikTok',
  'Snapchat',
  'Pinterest Tag',
  'Twitter Ads',
  'LinkedIn Insight Tag',
  'Google Tag Manager',
  'Bing Ads',
  'Criteo',
  'AdRoll',
];

// Analytics integrations to block when analytics consent is denied
var ANALYTICS_INTEGRATIONS = ['Google Analytics', 'Google Analytics 4', 'Mixpanel', 'Amplitude', 'Hotjar', 'FullStory', 'Heap'];

// Build integrations config based on consent state
var _buildSegmentIntegrations = function() {
  var integrations = { 'All': true };
  var state = _getConsentState();
  if (!state) {
    MARKETING_INTEGRATIONS.forEach(function(name) {
      integrations[name] = false;
    });

    ANALYTICS_INTEGRATIONS.forEach(function(name) {
      integrations[name] = false;
    });
    return integrations;
  }

  if (!state.marketing) {
    MARKETING_INTEGRATIONS.forEach(function(name) {
      integrations[name] = false;
    });
  }
  if (!state.analytics) {
    ANALYTICS_INTEGRATIONS.forEach(function(name) {
      integrations[name] = false;
    });
  }
  return integrations;
};

const withAnalytics = (Component) => (props) => {
  const page = (name, category, properties, options) => {
    let props = {
      ...properties,
      isMobileApp: !!window && !!window.ReactNativeWebView,
    };
    if (window.analytics) {
      var state = _getConsentState();

      var integrations = _buildSegmentIntegrations();

      window.analytics.page(category, name, props, {
        ...options,
        integrations,
        context: {
          ip: '0.0.0.0',
          integrations,
          consent: {
            categoryPreferences: {
              Essentials: true,
              Marketing: (!!state && !!state.marketing) || false,
              Analytics: (!!state && !!state.analytics) || false,
            },
          },
        },
      });
    }
  };

  const track = (name, properties, options) => {
    if (window.analytics) {
      let props = {
        ...properties,
        isMobileApp: !!window && !!window.ReactNativeWebView,
      };

      var state = _getConsentState();

      var integrations = _buildSegmentIntegrations();

      window.analytics.track(name, props, {
        ...options,
        integrations,
        context: {
          ip: '0.0.0.0',
          integrations,
          consent: {
            categoryPreferences: {
              Essentials: true,
              Marketing: (!!state && !!state.marketing) || false,
              Analytics: (!!state && !!state.analytics) || false,
            },
          },
        },
      });
    }
  };

  const Identify = (userId, traits, options, callback) => {
    // return
    if (window.analytics) {
      window.analytics.identify(userId, traits, { ...options, isMobileApp: !!window && !!window.ReactNativeWebView, context: { ip: '0.0.0.0' } }, callback);
    }
  };

  const Alias = (userId, properties, options) => {
    // return
    if (window.analytics) {
      let props = {
        ...properties,
        isMobileApp: !!window && !!window.ReactNativeWebView,
      };
      window.analytics.alias(userId, props, {
        ...options,
        context: { ip: '0.0.0.0' },
      });
    }
  };

  const logRevenue = (price, revenue, discount, coupon, products, orderId, affiliation) => {
    track('Order Completed', {
      orderId,
      affiliation,
      total: price,
      revenue: revenue,
      shipping: 1,
      discount: discount,
      coupon: coupon,
      currency: 'USD',
      products,
    });
    track('Blue Trench Coat', {
      orderId,
      affiliation,
      total: price,
      revenue: revenue,
      shipping: 1,
      discount: discount,
      coupon: coupon,
      currency: 'USD',
      products,
    });
  };

  const logCancel = (price, revenue, discount, coupon, products, orderId, affiliation, reason) => {
    track('Order Cancelled', {
      orderId,
      affiliation,
      total: price,
      revenue: revenue,
      shipping: 1,
      discount: discount,
      coupon: coupon,
      currency: 'USD',
      products,
      reason,
    });
  };

  const rest = {
    ...props,
    analytics: {
      page,
      track,
      Identify,
      Alias,
      logRevenue,
      logCancel,
    },
  };

  return <Component {...rest} />;
};

export default withAnalytics;
